export default __webpack_public_path__ + "static/media/park_payment_success.527b436e.png";